import { useEffect, useState } from 'react'
import { dashboardApi } from '../services/api'

export interface EfficiencyDay { date: string; task: number; email: number; call: number; meeting: number }
export interface EfficiencySnapshot { series: EfficiencyDay[]; summary: { handled7: number; arrived7: number; keepUpPct: number } }

export function useDashboardEfficiency() {
  const [snapshot, setSnapshot] = useState<EfficiencySnapshot | null>(null)
  useEffect(() => {
    let on = true
    Promise.resolve(dashboardApi.efficiency())
      .then((r: any) => { const data = r?.data ?? r; if (on) setSnapshot(data?.snapshot ?? null) })
      .catch(() => {})
    return () => { on = false }
  }, [])
  return snapshot
}
